export default __webpack_public_path__ + "static/colibri-0-web-1ae9d16928e41d09e06aa131998e1531.pdf";